// Copyright (C) 2021 Bystronic Laser AG

export enum BendLayoutTab {
  BendOverview,
  BendSummary,
  BendIntradayAvailability,
  BendProductionHistory,
  BendTrends,
  BendNewTrends,
}
